export const ENTRY_POINT_ID_CODE_REVIEWER =
  '21ef4844-70ac-4b41-a35d-484da32d04a7';

export const API_COLLECT_FEEDBACK =
  '/gateway/api/feedback-collector-api/v2/feedback';

// Custom fields
export const CAN_BE_CONTACTED_VALUE = { id: '10109' };
export const CANNOT_BE_CONTACTED_VALUE = { id: '10111' };
export const CONTACT_FIELD_ID = 'customfield_10043';
export const FULL_NAME_FIELD_ID = 'customfield_10045';
export const CONTEXT_FIELD_ID = 'customfield_10047';
